import { Tooltip, Typography } from '@mui/material';
import React from 'react';

type KpiWorkunitGridData = {
  status?: string;
};

const EDeliveryCell = React.memo(({ status }: KpiWorkunitGridData) => {
  // Correctly scopes the variable locally to avoid global 'status' conflicts
  const displayStatus = status === 'yes' ? 'In E-Delivery' : 'Not in E-Delivery';

  return (
    <>
      <Tooltip title={displayStatus}>
        <Typography variant="body2" noWrap>
          {displayStatus}
        </Typography>
      </Tooltip>
    </>
  );
});

export default EDeliveryCell;
